import { Button, Card, Drawer } from '@weezevent/nacre';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Modes } from '../constants';
import { FormInput, FormSelect, FormTextArea } from '../../../../../../../components/form';
import { BankAccountModel } from '../../constants';
import { BankAccountModelFields } from './BankAccountModelFields';
import { useWatch } from 'react-hook-form';
import classes from '../../../../../style/main.module.scss';

export const BankAccountDrawer = ({ isOpen, onClose, mode, onSubmit, isSubmitting }) => {
    const { t } = useTranslation();

    const config = {
        [Modes.CREATE]: {
            title: t('sauron.financeModule.bankAccounts.drawer.create.title'),
            subtitle: t('sauron.financeModule.bankAccounts.drawer.create.subtitle'),
            submitCta: t('sauron.financeModule.bankAccounts.drawer.create.submitCta')
        },
        [Modes.EDIT]: {
            title: t('sauron.financeModule.bankAccounts.drawer.edit.title'),
            subtitle: t('sauron.financeModule.bankAccounts.drawer.edit.subtitle'),
            submitCta: t('sauron.financeModule.bankAccounts.drawer.edit.submitCta')
        }
    };

    const model = useWatch({ name: 'bankAccountModel' });

    return (
        <Drawer
            classNames={{
                root: classes.drawerRoot
            }}
            open={isOpen}
            onClose={onClose}
            header={<Drawer.Header title={config[mode].title} subtitle={config[mode].subtitle} icon="file" iconOffsets={[0, 1.5]} />}
            footer={
                <Drawer.Footer
                    actions={[
                        <Button as="button" key="cancel" onClick={onClose}>
                            {t('common.cta.cancel')}
                        </Button>,
                        <Button as="button" key="save" primary onClick={onSubmit} isLoading={isSubmitting}>
                            {config[mode].submitCta}
                        </Button>
                    ]}
                />
            }
        >
            <Card>
                <Card.Header>
                    <Card.Title>{t('sauron.financeModule.bankAccounts.drawer.card.title')}</Card.Title>
                </Card.Header>
                <Card.Content>
                    <FormInput
                        name="bankAccountName"
                        label={t('sauron.financeModule.bankAccounts.drawer.fields.bankAccountName.label')}
                        placeholder={t('sauron.financeModule.bankAccounts.drawer.fields.bankAccountName.placeholder')}
                        required
                    />
                    <FormTextArea
                        name="description"
                        label={t('sauron.financeModule.bankAccounts.drawer.fields.description.label')}
                        placeholder={t('sauron.financeModule.bankAccounts.drawer.fields.description.placeholder')}
                    />
                    <FormSelect
                        name="bankAccountModel"
                        label={t('sauron.financeModule.bankAccounts.drawer.fields.bankAccountModel.label')}
                        placeholder={t('sauron.financeModule.bankAccounts.drawer.fields.bankAccountModel.placeholder')}
                        required
                        options={[
                            {
                                text: 'IBAN',
                                value: BankAccountModel.IBAN
                            },
                            {
                                text: 'CLABE',
                                value: BankAccountModel.CLABE
                            },
                            {
                                text: 'RBC',
                                value: BankAccountModel.RBC
                            }
                        ]}
                    />
                    <BankAccountModelFields model={model} />
                </Card.Content>
            </Card>
        </Drawer>
    );
};
